export const REFERRAL_QUERY_PARAMS = {
  legacy: ['ppu', 'ppk'],
  actual: ['ibp', 'ibl', 'ibk'],
};
